export default class BrandModelService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    } 
  
    listBrandModels(filterParams) {
      let query = '';
  
      query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
      query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
      query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
      query += `&ascending=${filterParams.pageCriteria.ascending}`;
  
      if (filterParams.brandName) {
        query += `&brandName=${filterParams.brandName}`;
      }

      if (filterParams.brandModelName) {
        query += `&brandModelName=${filterParams.brandModelName}`;
      }      
  
      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/brandmodel/list' + query);
    }
  }
  


// WEBPACK FOOTER //
// ./client/app/components/admin/brandModelManagement/BrandModel.Service.js